import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FeedProfile } from '@vestiaire/api-sdk-angular';
import { ISeeMemberEvent } from '../feed-card-profile/feed-card-profile.component';
import { ImagesService } from '@app/shared/components/images/services/images.service';

@Component({
  selector: 'vc-feed-suggestions-profile',
  templateUrl: './feed-suggestions-profile.component.html',
  styleUrls: ['./feed-suggestions-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedSuggestionsProfileComponent implements OnInit {
  @Input() profile: FeedProfile;
  @Output() hideProfileSuggestion = new EventEmitter<string>();
  @Output() onFollow = new EventEmitter<any>();
  @Output() onSeeProfile = new EventEmitter<ISeeMemberEvent>();

  avatarSrc: string;

  ngOnInit() {
    this.avatarSrc = ImagesService.buildUrl(
      `/profil/${this.profile.describes.picture ? this.profile.describes.picture : 'missing_avatar.gif'}`
    );
  }

  hideProfile() {
    this.hideProfileSuggestion.emit(this.profile.describes.id);
  }

  onClickFollow(profileId: string) {
    if (profileId === this.profile.describes.id) {
      this.profile.isFollowed = true;
      const trackingKey = this.profile.trackingKey;
      this.onFollow.emit({ profileId, trackingKey });
    }
  }

  onClickSeeProfile($event: ISeeMemberEvent) {
    this.onSeeProfile.emit($event);
  }
}
